/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export interface TimeTravelFastForwardResponse {
  user_id: string;
  advance_days: number;
  simulated_now_utc: string;
  workflows_signaled: string[];
  pending_notifications_expired: string[];
}
